<template>
  <v-card class="mt-0">
    <v-expand-transition v-if="searched && searched.length > 0">
      <v-expansion-panels class="mt-0">
        <v-expansion-panel v-for="(ap, index) in searched" :key="index">
          <v-expansion-panel-header expand-icon="$sl-arrow-down" two-line>
            <div
              @click="
                $nextTick(() => {
                  $router.push({
                    name: 'CompanyApprentice',
                    params: {
                      id: $route.params.id,
                      employee_id: (ap.book && ap.book.apprenticeship && ap.book.apprenticeship.id) ? ap.book.apprenticeship.id 
                      : (ap.education && ap.education.currentApprenticeship && ap.education.currentApprenticeship.id) ? ap.education.currentApprenticeship.id : -1,
                    },
                  });
                })
              "
            >
              <div
                class="header-title text-capitalize"
                v-if="ap && ap.book && ap.book.person"
              >
                {{ ap.book.person | fullName }}
              </div>
              <div
                class="header-title text-capitalize"
                v-else-if="ap && ap.education && ap.education.person"
              >
                {{ ap.education.person | fullName }}
              </div>
              <div class="caption gray">
                {{ ap.startDate | date }} — {{ ap.endDate | date }}
              </div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <h6 class="subtitle-2">{{ $t("company.exemption-issued") }}</h6>
            <p class="caption" v-if="ap.approvedBy">
              {{ ap.approvedBy.firstName || "" }} {{ ap.approvedBy.lastName || "" }}
            </p>
            <h6 class="subtitle-2">{{ $t("company.exemption-start-date") }}</h6>
            <p class="caption">{{ ap.approvedAtSecondary | date }}</p>
            <h6 class="subtitle-2">{{ $t("company.startFrom") }}</h6>
            <p class="caption">{{ ap.startDate | date }}</p>
            <h6 class="subtitle-2">{{ $t("company.until") }}</h6>
            <p class="caption">{{ ap.endDate | date }}</p>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-expand-transition>
  </v-card>
</template>

<script>
import API from "@/services/api.js";
import ActionButton from "@/components/Common/ActionButton";
import filter from "lodash/filter";
import find from "lodash/find";

const SugarDate = require("sugar/date");

export default {
  name: "CompanyPausedPersonDetail",

  props: {
    searched: {
      type: Array,
      default: [],
    },
  },

  created() {
    //console.log("inits::", this.searched);
  },

  computed: {},

  methods: {},
};
</script>
<style scoped></style>
